import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ROOT_URL } from "../../api/ApiConfig";

/**
 * GET /chat-room/room/:id — returns roomData with populated group_id / groups.
 */
export const getChatRoomById = createAsyncThunk(
  "chat-room/room-by-id",
  async ({ id }, { getState, rejectWithValue }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;
    try {
      const response = await fetch(`${ROOT_URL}/chat-room/room/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error?.response || error?.message || error);
    }
  }
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  response: null,
  error: null,
};

const GetChatRoomById = createSlice({
  name: "GetChatRoomById",
  initialState,
  reducers: {},
  extraReducers: {
    [getChatRoomById.pending]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [getChatRoomById.fulfilled]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      isError: false,
      response: action.payload,
    }),
    [getChatRoomById.rejected]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: true,
      error: action.payload,
    }),
  },
});

export default GetChatRoomById;
